import styled from 'styled-components'

export const StyledSelectList = styled.div<{
  $orientation: 'up' | 'down'
  $maxHeight?: string
  $minWidth?: string
}>`
  ${({ theme, $orientation, $maxHeight, $minWidth }) => `
    position: absolute;
    top: ${
      $orientation === 'down' ? 'calc(100% + ' + theme.sizes[2] + ')' : 'auto'
    };
    bottom: ${
      $orientation === 'up' ? 'calc(100% + ' + theme.sizes[2] + ')' : 'auto'
    };
    left: 0;
    border-radius: ${theme.borderRadii.medium};
    overflow: hidden;
    box-shadow: ${theme.boxShadows.medium};
    transition: 0.2s all;
    width: 100%;
    min-width: ${$minWidth || 'auto'};
    max-height: ${$maxHeight || 'auto'};
    z-index: ${theme.zIndex.select};
    text-align: left;
    background-color: white;
  `}
`
